import * as React from 'react';
import { ReportFieldDefinition } from "../../../../models";
import Typography from '../../../Typography';
import { DateField, TextInputField } from '../../fields';

interface DateFieldProps {
    id: string,
    value?: string,
    fieldDefinition: ReportFieldDefinition,
    style?: React.CSSProperties,
    readOnly?: boolean,
    invalid?: boolean,
    onChange?: (value: string) => void,
}

export const DateReportField: React.FC<DateFieldProps> = ({
    id,
    value,
    style,
    invalid,
    readOnly,
    onChange,
}) => {
    return readOnly 
        ? <Typography id={id} style={style}>{value}</Typography>
        : <DateField id={id} style={style} invalid={invalid} type="date" value={value} onChange={onChange} disabled={readOnly}/>
}